import React from 'react'
import EditClassificationRuleWorkflow from 'application/categories/EditClassificationRuleWorkflow'

function AddClassificationRule() {
    return <EditClassificationRuleWorkflow onSuccess="/classification-rules" static={true} />
}

export default AddClassificationRule
